import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import useMapReducer from './Reducers/MapReducer'
import useLocaleReducer from './Reducers/LocaleReducer'
import './i18n'

import 'bootstrap/dist/css/bootstrap.min.css';
import Context from './Context';
import { HashRouter, Routes, Route } from "react-router-dom";


function Store({children}) {
  const value = {
    map: useMapReducer(),
    locale: useLocaleReducer()
  }
  return (
    <Context.Provider value={value}>
      {children}
    </Context.Provider>
  )
}

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <>
    <Store>
      <HashRouter>
        <Routes>
          <Route path='/' element={<App></App>} />
        </Routes>
      </HashRouter>
    </Store>
  </>
);
